/**
 * @generated SignedSource<<4abc01d984cca4a57bac55e4ce05d848>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClinicianAvailabilitiesTable_query$data = {
  readonly clinicianAvailabilities: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly clinician: {
          readonly user: {
            readonly firstName: string;
            readonly lastName: string;
            readonly slug: string | null;
          } | null;
        } | null;
        readonly endsAt: any | null;
        readonly googleCalendarEventId: string | null;
        readonly id: string;
        readonly rowId: any;
        readonly startsAt: any;
        readonly " $fragmentSpreads": FragmentRefs<"UpdateClinicianAvailabilityModal_clinicianAvailability">;
      };
    }>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CreateClinicianAvailabilityModal_query" | "UpdateClinicianAvailabilityModal_query">;
  readonly " $fragmentType": "ClinicianAvailabilitiesTable_query";
};
export type ClinicianAvailabilitiesTable_query$key = {
  readonly " $data"?: ClinicianAvailabilitiesTable_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClinicianAvailabilitiesTable_query">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "clinicianAvailabilities"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        "STARTS_AT_ASC"
      ],
      "kind": "LocalArgument",
      "name": "orderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ClinicianAvailabilitiesTablePaginationQuery.graphql')
    }
  },
  "name": "ClinicianAvailabilitiesTable_query",
  "selections": [
    {
      "alias": "clinicianAvailabilities",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "ClinicianAvailabilitiesConnection",
      "kind": "LinkedField",
      "name": "__ClinicianAvailabilitiesTable_clinicianAvailabilities_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClinicianAvailabilitiesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClinicianAvailability",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startsAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endsAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Clinician",
                  "kind": "LinkedField",
                  "name": "clinician",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "googleCalendarEventId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UpdateClinicianAvailabilityModal_clinicianAvailability"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateClinicianAvailabilityModal_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateClinicianAvailabilityModal_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "3f8ff38640dbf00fbb33407f985ca0e6";

export default node;
